import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Affiliation from "./pages/Affiliation";
import Membership from "./pages/Membership";
import MembershipFormPrint from "./pages/MembershipFormPrint";
import Rights from "./pages/Rights";
import LegalSupport from "./pages/LegalSupport";
import Welfare from "./pages/Welfare";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import { Privacy, Terms } from "./pages/Legal";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const NotFound = () => (
  <div className="container-x py-32 text-center" data-testid="not-found">
    <h1 className="font-display text-4xl font-extrabold text-navy">Page not found</h1>
    <Link to="/" className="btn-primary mt-8">Back to home</Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/affiliation" element={<Affiliation />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/employee-rights" element={<Rights />} />
          <Route path="/legal-support" element={<LegalSupport />} />
          <Route path="/welfare" element={<Welfare />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="/membership-form" element={<MembershipFormPrint />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}

export default App;
